/**
 * design.md §2 People: each person has one colour, the same on every screen — their
 * avatar, their items on a calendar. Picked from eight `person` tokens by their name,
 * so it never changes between visits and needs nothing stored.
 */

// Whole class names, so Tailwind finds them in the source.
const TONES = [
  'bg-person-1-soft text-person-1',
  'bg-person-2-soft text-person-2',
  'bg-person-3-soft text-person-3',
  'bg-person-4-soft text-person-4',
  'bg-person-5-soft text-person-5',
  'bg-person-6-soft text-person-6',
  'bg-person-7-soft text-person-7',
  'bg-person-8-soft text-person-8',
] as const

/** The soft background and text classes of a person's colour. */
export function personTone(name: string): string {
  let hash = 0
  for (const char of name.trim().toLowerCase()) hash = (hash * 31 + char.charCodeAt(0)) >>> 0
  return TONES[hash % TONES.length]
}
